import { apiFetch } from "../http";
export async function sendUserActionEvents(params) {
    return apiFetch("/user/api/analytics/events/", {
        baseUrl: params.baseUrl,
        token: params.token,
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ events: params.events }),
        redirectOnUnauthorized: false,
        waitForBackgroundTask: false,
        keepalive: params.keepalive,
        requestTimeoutMs: params.requestTimeoutMs,
        signal: params.signal,
    });
}
export async function getAdminUserAnalytics(params) {
    const query = new URLSearchParams();
    if (params.userId)
        query.set("user_id", params.userId);
    if (params.userSearch)
        query.set("user_search", params.userSearch);
    if (params.actionType)
        query.set("action_type", params.actionType);
    if (params.actionName)
        query.set("action_name", params.actionName);
    if (params.platform)
        query.set("platform", params.platform);
    if (params.clientType)
        query.set("client_type", params.clientType);
    if (params.travelPlanId)
        query.set("travel_plan_id", params.travelPlanId);
    if (params.itemTravelId)
        query.set("item_travel_id", params.itemTravelId);
    if (params.packageId)
        query.set("package_id", params.packageId);
    if (params.dateFrom)
        query.set("date_from", params.dateFrom);
    if (params.dateTo)
        query.set("date_to", params.dateTo);
    if (params.limit !== undefined)
        query.set("limit", String(params.limit));
    if (params.offset !== undefined)
        query.set("offset", String(params.offset));
    const suffix = query.toString() ? `?${query.toString()}` : "";
    return apiFetch(`/user/api/admin/analytics/${suffix}`, {
        baseUrl: params.baseUrl,
        token: params.token,
        method: "GET",
        headers: { Accept: "application/json" },
        redirectOnUnauthorized: false,
        waitForBackgroundTask: false,
    });
}
